import {
  buildIndividualFromSaved,
  isIndividualBlank,
} from "./requestHelpers";

export const buildIndividualsToAppend = (
  existingIndividuals = [],
  selectedItems = []
) => {
  const normalizedIndividuals = selectedItems.map((item) =>
    buildIndividualFromSaved(item.data || item)
  );

  const individuals =
    existingIndividuals.length === 1 &&
    isIndividualBlank(existingIndividuals[0])
      ? []
      : existingIndividuals;

  return [...individuals, ...normalizedIndividuals];
};